import { FAQSection } from 'pages/LandingPage/FaqSection';
import { DefaultTemplate } from 'shared/templates/DefaultTemplate';
import { HowItWorksSection } from './HowItWorksSection';
import { BenefitsSection } from './BenefitsSection';
import { MultiStepForm } from 'shared/components/Form/MultiStepForm';

export const LandingPage = () => {
  return (
    <DefaultTemplate>
      <MultiStepForm />
      <BenefitsSection />
      <HowItWorksSection />
      <FAQSection />
    </DefaultTemplate>
  );
};
